export type NavItem = {
  label: string;
  href: string;
  description?: string;
  children?: NavItem[];
};

export const mainNav: NavItem[] = [
  { label: "Domů", href: "/" },
  {
    label: "Služby",
    href: "/sluzby",
    children: [
      {
        label: "Účetnictví",
        href: "/sluzby/ucetnictvi",
        description: "Vedení účetnictví a daňové evidence pro OSVČ i firmy.",
      },
      {
        label: "Daňové poradenství",
        href: "/sluzby/danove-poradenstvi",
        description: "Přiznání, optimalizace a zastoupení před správcem daně.",
      },
      {
        label: "Zpracování mezd",
        href: "/sluzby/zpracovani-mezd",
        description: "Mzdová agenda, odvody a komunikace s úřady.",
      },
    ],
  },
  { label: "O firmě a tým", href: "/o-firme" },
  { label: "Poradna", href: "/poradna" },
  { label: "Dokumenty", href: "/dokumenty" },
  { label: "Kontakt", href: "/kontakt" },
];

export const footerNav: NavItem[] = [
  { label: "Domů", href: "/" },
  { label: "Služby", href: "/sluzby" },
  { label: "Účetnictví", href: "/sluzby/ucetnictvi" },
  { label: "Daňové poradenství", href: "/sluzby/danove-poradenstvi" },
  { label: "Zpracování mezd", href: "/sluzby/zpracovani-mezd" },
  { label: "O firmě a tým", href: "/o-firme" },
  { label: "Poradna", href: "/poradna" },
  { label: "Dokumenty", href: "/dokumenty" },
  { label: "Kontakt", href: "/kontakt" },
  { label: "Ochrana osobních údajů", href: "/ochrana-osobnich-udaju" },
];

export const primaryCta = {
  label: "Domluvit konzultaci",
  href: "/kontakt",
} as const;
